import { Component, Input } from '@angular/core';
import { Resultat } from '../../../shared/models/resultat.model';
import { ResultatService } from '../../../services/resultat.service';
import { TypAvSnittkurs } from '../../../shared/enums/typAvSnittkurs.enum';
import { AvtalstypEnum } from '../../../shared/enums/avtalstyp.enum';

@Component({
  selector: 'app-resultat-details',
  templateUrl: './resultat-details.component.html',
  styleUrls: ['./resultat-details.component.scss']
})
export class ResultatDetailsComponent {

  @Input() resultat: Resultat;
  @Input() index = 0;

  constructor(private readonly resultatService: ResultatService) {
  }

  tranformDigitValutakurs(decimal: number): string {
    return this.resultatService.tranformDigitToLocaleString(decimal, '0.0-10');
  }

  tranformDigit(decimal: number): string {
    return this.resultatService.tranformDigitToLocaleString(decimal);
  }

  tranformDigitWithCurrency(decimal: number, currency: string): string {
    return this.resultatService.tranformDigitToLocaleStringWithCurrency(decimal, currency);
  }

  isGreaterThanZero(value: number): boolean {
    return value > 0;
  }

  getBankdagText(): string | undefined {

    switch (this.resultat.inkomstDetails.typAvSnittkurs) {
      case TypAvSnittkurs.DAGSKURS: {
        let text;
        const result = this.resultatService.compareDate(
          this.resultat.inkomstDetails.utbetalningsdatum, this.resultat.inkomstDetails.inkomstValuta.valutadag);

        if (result === 0) { // 0 if dates are same
          text = '';
        } else if (result === 1) { // 1 if the first date is greater than second
          text = 'Närmaste bankdagen före datumet du angav';
        } else if (result === -1) { // -1 if the first date is less than second
          text = 'Närmaste bankdagen efter datumet du angav';
        }
        return text;
      }
      case TypAvSnittkurs.GENOMSNITT_MANAD: {
        return 'Genomsnittlig valutakurs för den månad du angav';
      }
      case TypAvSnittkurs.GENOMSNITT_AR: {
        return 'Genomsnittlig valutakurs för det år du angav';
      }
    }
  }

  visaMaximalAvrakning(avtalstyp: AvtalstypEnum): boolean {
    return avtalstyp === AvtalstypEnum.PROCENT_BEGRANSNING || avtalstyp === AvtalstypEnum.ENDAST_HEMVISTSTAT;
  }

  isWarningHighTax(inkomst: number, skatt: number) {
    return skatt > inkomst * .5;
  }
}
